import { render, staticRenderFns } from "./PaidStatus.vue?vue&type=template&id=d857452a&scoped=true&"
import script from "./PaidStatus.vue?vue&type=script&lang=js&"
export * from "./PaidStatus.vue?vue&type=script&lang=js&"
import style0 from "./PaidStatus.vue?vue&type=style&index=0&id=d857452a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d857452a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d857452a')) {
      api.createRecord('d857452a', component.options)
    } else {
      api.reload('d857452a', component.options)
    }
    module.hot.accept("./PaidStatus.vue?vue&type=template&id=d857452a&scoped=true&", function () {
      api.rerender('d857452a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/PaidStatus.vue"
export default component.exports